import { newsItems } from "@/mocks/news";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useSeo } from "@/hooks/useSeo";
import NewsCard from "./components/NewsCard";
import NewsBreadcrumb from "./components/NewsBreadcrumb";
import FaqSection from "@/components/feature/FaqSection";

const newsFaq = [
  {
    question: "GRANSTARKはどんな警備会社ですか？",
    answer:
      "株式会社GRANSTARKは2019年創業の大阪密着の警備会社です。大阪府公安委員会認定（第62003216号）を取得しており、交通誘導・高速道路・イベント（雑踏）・施設警備の4分野に対応しています。",
  },
  {
    question: "GRANSTARKに警備を依頼するにはどうすればいいですか？",
    answer:
      "お電話（06-6786-9252）またはホームページのお問い合わせフォームからご連絡ください。最短即日でご対応いたします。",
  },
];

export default function News() {
  useSeo({
    title: "NEWS・お知らせ｜株式会社GRANSTARK｜大阪の警備会社",
    description:
      "株式会社GRANSTARKの最新ニュース・お知らせ。大阪・関西の警備会社として、採用情報や警備に関する情報を随時更新しています。",
    ogUrl: "https://www.gs-granstark.com/news",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.gs-granstark.com/news#webpage",
        url: "https://www.gs-granstark.com/news",
        name: "NEWS・お知らせ｜株式会社GRANSTARK｜大阪の警備会社",
        description:
          "株式会社GRANSTARKの最新ニュース・お知らせ。大阪・関西の警備会社として、採用情報や警備に関する情報を随時更新しています。",
        isPartOf: { "@id": "https://www.gs-granstark.com/#website" },
        publisher: { "@id": "https://www.gs-granstark.com/#business" },
        inLanguage: "ja",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: newsFaq.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      },
    ],
  });

  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  const sortedNews = [...newsItems].sort(
    (a, b) => new Date(b.isoDate).getTime() - new Date(a.isoDate).getTime()
  );

  return (
    <div>
      <NewsBreadcrumb />

      <section className="relative h-[420px] md:h-[520px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none"
          style={{
            backgroundImage:
              "url('/images/kv-main.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/50 via-navy/60 to-navy/80 pointer-events-none" />
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center px-4">
            <span className="text-gold text-sm tracking-[4px] font-bold block mb-3">
              NEWS
            </span>
            <h1 className="text-4xl md:text-5xl font-black text-white">
              ニュース
            </h1>
            <p className="text-gray-300 mt-4 text-lg">
              GRANSTARKからのお知らせ
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-16 md:py-24">
        <div ref={ref} className="w-full px-4 md:px-8 max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-navy">
              NEWS
            </h2>
            <p className="text-gray-500 mt-2 text-sm">最新情報</p>
          </div>

          <div className="space-y-4 md:space-y-6">
            {sortedNews.map((item, i) => (
              <NewsCard
                key={item.id}
                item={item}
                index={i}
                isVisible={isVisible}
              />
            ))}
          </div>
        </div>
      </section>

      <FaqSection items={newsFaq} bgColor="bg-gray-50" />
    </div>
  );
}
